<template lang="pug">
div
  div(v-for="item in filteredItems" :key="item.name")
    BriqTreeBranch(:item="item" :itemsWithExpansionState="itemsWithExpansionState")
      template(v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope")
        slot(:name="slot" v-bind="scope")
</template>

<script>
import { curry, includes, toLower, reduce, append, pipe, prop } from 'ramda'
import BriqTreeBranch from './BriqTreeBranch.vue'

const caseInsensitiveMatch = curry((q, x) => includes(toLower(q))(toLower(x)))

const itemMatchesQuery = q => pipe(prop('name'), caseInsensitiveMatch(q))

const filterWithQuery = q =>
  reduce((a, n) => {
    if (itemMatchesQuery(q)(n)) return append(n, a) // all children will be shown
    if (!n.children || !n.children.length) return a
    else {
      const filteredChildren = filterWithQuery(q)(n.children)
      return !filteredChildren.length ? a : append({ ...n, children: filteredChildren }, a) // all parents will be shown
    }
  }, [])

export default {
  name: 'BriqTreeView',
  components: { BriqTreeBranch },
  props: {
    items: { type: Array, required: true },
    itemsWithExpansionState: { type: Array, required: true },
    query: String,
  },
  computed: {
    filteredItems() {
      if (!this.query) return this.items
      return filterWithQuery(this.query)(this.items)
    },
  },
}
</script>

<style scoped lang="stylus">
.sitemap-page
  width 910px

.slide-move
  transition transform .5s ease-out
</style>
